import { useSelector } from "../../../redux/store";
import { activePlayerSelector } from "../../../redux/selectors/activePlayerSelector";
import { useQuery } from "react-query";
import wiki from "wikipedia";

export const useWikipedaSearchIfIsNotCurrentUser = () => {
  const activePlayer = useSelector(activePlayerSelector);
  const currentUser = useSelector((state) => state.auth.user);

  const isActiveSameCurrent = activePlayer?.userId === currentUser?.uid;
  const inventedName = activePlayer?.inventedName;

  const show = !!inventedName && !isActiveSameCurrent;

  const resultQuery = useQuery(
    ["wikipedia", inventedName],
    async () => {
      wiki.setLang("de");
      return wiki.summary(inventedName!, {});
    },
    {
      enabled: show,
      refetchOnMount: false,
      staleTime: Infinity,
    }
  );

  return resultQuery;
};
